import { PageType } from './components/CommentsEmbedScript';
import { runningClientSide } from '@benzinga/utils';
import { TrackingManager } from '@benzinga/tracking-manager';
import { SessionPropsExtension } from '@benzinga/session-context';

export const rootURL = 'https://comments.benzinga.com';

type Action = 'open-drawer' | 'login-click' | 'comment-created';

export const handleCommentsAnalyticsEvent = (type: PageType, actionType: Action, session: SessionPropsExtension) => {
  if (!type) return;
  if (actionType === 'open-drawer') {
    session.getManager(TrackingManager).trackCommentEvent('open_drawer', {
      page_type: type,
    });
  } else if (actionType === 'login-click') {
    session.getManager(TrackingManager).trackCommentEvent('auth', {
      page_type: type,
    });
  } else if (actionType === 'comment-created') {
    session.getManager(TrackingManager).trackCommentEvent('new_message', {
      page_type: type,
    });
  }
};

export const injectCoralCommentsScript = ({
  onError,
  onLoad,
}: {
  onError?: () => void;
  onLoad?: () => void;
} = {}) => {
  if (!runningClientSide()) return;

  const existingScript = document.querySelector('#coral-comments-script');
  if (existingScript) return;

  const src = `${rootURL}/assets/js/embed.js`;

  const scriptElement = document.createElement('script');
  scriptElement.src = src;
  scriptElement.setAttribute('async', 'false');
  scriptElement.setAttribute('defer', 'true');
  scriptElement.setAttribute('id', 'coral-comments-script');
  if (typeof onLoad === 'function') {
    scriptElement.onload = onLoad;
  }
  scriptElement.onerror = (event: Event | string) => {
    if (typeof event === 'object' && event?.type === 'error') {
      console.error('Failed to inject Coral Comments script');
    }
    typeof onError === 'function' && onError();
  };

  document.body.appendChild(scriptElement);
};
